
<template>
  <!--查看开门日志-->
  <div>
    <p style="margin-bottom: 24px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 600;
       font-size: 16px;"
    >{{`${$route.query.name}（${$route.query.label}）`}}</p>
    <x-tabula
      ref="table"
      :excludeResetKey="['member_id']"
      :dataSource="dataSource"
      rowKey="open_log_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'lookOpenLog',
  data () {
    return {
      searchList: [
        {
          props: ['area_id'],
          placeholder: '区域',
          options: [],
          inputType: 'cascader',
          expandTrigger: 'click',
          loadData: e => {
            this.regionSelect(0, 'searchList', '1,2,3', e);
          }
        },
        { props: ['community_id'], placeholder: '小区', options: [], inputType: 'select' },
        { props: ['create_date'], placeholder: ['开始时间', '结束时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [],
      rowOptList: [
        { text: '查看', handle: (row) => this.showPicture(row.face_img), key: 'show' }
      ],
      columns: [
        { title: '开门时间', dataIndex: 'open_time', align: 'left', width: '' },
        { title: '所在小区', dataIndex: 'community_name', align: 'left', width: '' },
        { title: '通行门', dataIndex: 'position_name', align: 'left', width: '' },
        { title: '设备名称', dataIndex: 'device_name', align: 'left', width: '' },
        { title: '账号', dataIndex: 'mobile', align: 'left', width: '' },
        { title: '卡号', dataIndex: 'cardno', align: 'left', width: '' },
        { title: '开门方式', dataIndex: 'open_type_desc', align: 'left', width: '' },
        { title: '抓拍', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        area_id: undefined,
        community_id: undefined,
        create_date: undefined,
        member_id: undefined
      },
      listApi: {
        url: '/blacklist/open_log/',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {}
    };
  },
  created () {
    this.searchParams.member_id = this.$route.query.id;
    this.getSelect();
  },
  methods: {
    getSelect () {
      this.regionSelect(0, 'searchList');
      this.communitySelect(1, 'searchList', 1);
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
